module.exports = "https://web-assets.ifttt.com/packs/media/header/return_key_icon_gray-0dca982a.svg";